import React from 'react';

const NotFoundContainer = () => {
    return (
        <div>
            404 not found
        </div>
    );
};

export default NotFoundContainer;
